import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import ArticleCodeMP from "./ArticleCodeMP";
import { compose } from "redux";
import { connect } from "react-redux";
import { fetchArticleCodeMP, setCodeMP } from "store/articlecodemp-slice";

const ArticleCodeMPContainer = ({ articleCodeMP, setCodeMP, fetchArticleCodeMP }) => {
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setCodeMP(id);
    } else {
      setCodeMP("");
    }
  }, [id, setCodeMP]);

  useEffect(() => {
    if (articleCodeMP.codeMP) {
      fetchArticleCodeMP(articleCodeMP.codeMP);
    }
  }, [articleCodeMP.codeMP, fetchArticleCodeMP]);

  return <ArticleCodeMP state={{ articleCodeMP }} />;
};
const mapStateToProps = (state) => ({ articleCodeMP: state.articleCodeMP });

const dispatch = { fetchArticleCodeMP, setCodeMP };

export default compose(connect(mapStateToProps, dispatch))(ArticleCodeMPContainer);